import {
  SET_DATA_TABLE,
  SET_EMPTY_TABLE,
  SET_LEGENDA_MAPS,
  SET_NOTIFICATIONS,
  SET_PROGRESS_UPLOAD,
  SET_TRIGGER_TABLE,
} from "./type";

export function setDataTable(data) {
  return {
    type: SET_DATA_TABLE,
    payload: data,
  };
}

export function setLoading(data) {
  return {
    type: "GET_DATA_JSON",
    payload: data,
  };
}

export function setEmptyTable(data) {
  return {
    type: SET_EMPTY_TABLE,
    payload: data,
  };
}

export function setLegendaMaps(legenda) {
  return {
    type: SET_LEGENDA_MAPS,
    payload: legenda,
  };
}

export function setNotifications(notifications) {
  return {
    type: SET_NOTIFICATIONS,
    payload: notifications,
  };
}

export function setProgressUpload(progress) {
  return {
    type: SET_PROGRESS_UPLOAD,
    payload: progress,
  };
}

export function setTriggerTable(triggerTable) {
  return {
    type: SET_TRIGGER_TABLE,
    payload: triggerTable,
  };
}
